import type { AzioneInChat as DatiAzione } from '@masamune/shared';
import { Icon } from '../../components/ui/Icon';
import { conMaiuscola, useAzione } from './carteApi';
import './carte.css';

/**
 * Una modifica che MUNE ha fatto subito, dentro la sua risposta (29/10/2026, fetta 2D «Fa»
 * della Fase 2; os-planning/ai/fase-2-progetto.md, «Interfaccia»): «Fatto: task "Chiamare
 * Riccardo di Graci" per te, giovedì 29/10 · avvisati Discord e Andrea · Annulla». La frase la
 * scrive il codice del server, mai il modello (evento `azione`). «Annulla» la rimette com'era,
 * senza conferma perché è il gesto appena fatto (come l'Annulla del toast), anche a MUNE
 * spento; poi la riga dice «Annullato: task "…"». Se non si annulla più, dice perché. Le mail e
 * i messaggi già partiti restano: per questo la riga dice chi è stato avvisato.
 *
 * Computer: una riga sola, «Annulla» come un link in fondo; al passaggio sugli avvisati, cosa è
 * partito. Telefono: la frase, sotto chi è stato avvisato e il tasto «Annulla» alto 44, sotto il
 * pollice.
 */
export function AzioneInChat({ azione, mobile }: { azione: DatiAzione; mobile: boolean }): JSX.Element {
  const z = useAzione(azione);
  const icona = z.annullata ? 'undo' : 'check';

  if (mobile) {
    return (
      <div className="aic aic--m" data-annullata={z.annullata ? 'true' : undefined}>
        <Icon name={icona} size={14} strokeWidth={2.25} className="aic-icona" />
        <div className="aic-corpo">
          {/* Cambia con l'Annulla («Annullato: …»): i lettori di schermo lo dicono. */}
          <p className="aic-frase" role="status">{z.frase}</p>
          {z.avvisati && <p className="aic-nota">{conMaiuscola(z.avvisati)}</p>}
          {z.motivo && <p className="aic-nota">{z.motivo}</p>}
          {z.puoAnnullare && (
            <button type="button" className="btn btn-sm aic-annulla" disabled={z.annullando} onClick={z.annulla}>
              <Icon name="undo" size={12} /> {z.annullando ? 'Annullo…' : 'Annulla'}
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="aic" data-annullata={z.annullata ? 'true' : undefined}>
      <Icon name={icona} size={13} strokeWidth={2.25} className="aic-icona" />
      <p className="aic-riga">
        <span role="status">{z.frase}</span>
        {z.avvisati && <span className="aic-avvisati" title={z.dettaglioAvvisi ?? undefined}> · {z.avvisati}</span>}
        {z.motivo && <span className="aic-motivo"> · {z.motivo}</span>}
        {z.puoAnnullare && (
          <>
            {' · '}
            <button type="button" className="aic-link" disabled={z.annullando} onClick={z.annulla}>
              {z.annullando ? 'Annullo…' : 'Annulla'}
            </button>
          </>
        )}
      </p>
    </div>
  );
}
